<template>
  <div class="material-report-detail">
    <div class="material-info-row" :class="loading && 'loading'">
      <span>
        素材ID：
        <span class="text">{{ queryForm.id }}</span>
      </span>
      <span>
        素材名称：
        <span class="text">{{ name }}</span>
      </span>
      <span>
        设计者：
        <span class="text">{{ author }}</span>
      </span>
      <span>
        上传时间：
        <span class="text">{{ creatime }}</span>
      </span>
    </div>
    <div class="query-form">
      <ElForm inline label-width="80px" @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="数据游戏组">
          <el-select
            v-model="queryForm.dataGroupIds"
            style="width: 200px"
            multiple
            collapse-tags
            filterable
            clearable
            @change="sendEvent"
            placeholder="全部"
          >
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="数据游戏" label-width="68px">
          <el-select
            v-model="queryForm.dataGameIds"
            style="width: 200px"
            multiple
            collapse-tags
            filterable
            clearable
            @change="sendEvent"
            placeholder="全部"
          >
            <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体" label-width="40px">
          <el-select
            v-model="queryForm.mediaIds"
            multiple
            collapse-tags
            filterable
            clearable
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
          >
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="平台" label-width="40px">
          <el-select
            v-model="queryForm.platforms"
            multiple
            collapse-tags
            filterable
            clearable
            @change="sendEvent"
            style="width: 140px"
            placeholder="全部"
          >
            <el-option v-for="item in platformData2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="投放人员">
          <el-select
            v-model="queryForm.launchOpIdList"
            @change="sendEvent"
            filterable
            collapse-tags
            multiple
            clearable
            placeholder="全部"
            style="width: 180px"
          >
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="统计时间">
          <DateRangePicker v-model="queryForm.datetime" :clearable="false" @change="handleDatetime" style="width: 220px"></DateRangePicker>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button @click="modalColumn = true">自定义列</el-button>
          <el-button @click="downData" :loading="exportLoading">数据导出</el-button>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="table">
      <Viewport v-model="tableHeight">
        <m-report-table
          :loading="loading"
          :height="tableHeight - 10"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          @on-sort="sortTable"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="modalColumn"
      name="MaterAnalysisDCustomColumn"
      :data="rawTableCols"
      :sub-title="['基本数据', '创角留存', '创角LTV']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { isArray } from '@/common/js/utils'
import { datetimeToDay } from '@/common/js/filters'
import mixinTable from './mixin_table'
import { analysisCols } from '../data/material_record_detail_column'

import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import MReportTable from './components/detail-table.vue'
import { platformData2 } from '../data/platformData'
import { getMaterialAnalysisDetail, exportMaterialAnalysisDetail } from '@/api/report.model'
import { initPageData, GAME_GROUPS, GAMES, MEDIAS, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES, MEDIAS, SYS_USERS])

export default {
  name: 'materialAnalysisDetail',
  mixins: [mixinTable],
  components: { CustomColumn, MReportTable, DateRangePicker },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    }
  },
  methods: {
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const idx = ['planName', 'mediaName'].indexOf(prop)
        if (idx > -1) sums[index] = data[prop]
        else sums[index] = ''
      })
      return sums
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.queryForm.datetime = [newDate, end]
      }

      this.sendEvent()
    },

    sendEvent() {
      this.getData()
    },
    getData() {
      const [beginTime, endTime] = this.queryForm.datetime || []
      const param = {
        platforms: this.queryForm.platforms,
        mediaIds: this.queryForm.mediaIds,
        dataGameIds: this.queryForm.dataGameIds,
        dataGroupIds: this.queryForm.dataGroupIds,
        [this.dimImageDetail === '1' ? 'imageDetailId' : 'imageId']: this.queryForm.id,
        beginTime,
        endTime,
        sort: this.sort,
        order: this.order
      }

      if (this.queryForm.launchOpIdList?.length) {
        param.launchOpIdsStr = this.queryForm.launchOpIdList.join(',')
      }
      this.loading = true
      getMaterialAnalysisDetail(param).then((data) => {
        this.loading = false
        if (!data) return
        const { imageInfo, rows, sumdata } = data
        // 素材基本信息
        if (imageInfo) {
          this.name = imageInfo.imageName
          this.author = imageInfo.designerName
          this.creatime = typeof imageInfo.uploadTime === 'number' ? datetimeToDay(imageInfo.uploadTime) : imageInfo.uploadTime
        }
        if (isArray(rows) && sumdata) {
          this.sumdata = sumdata
          this.tableList = rows
        }
      })
    },
    downData() {
      const [beginTime, endTime] = this.queryForm.datetime || []
      const exportColumnOrderMap = {}
      this.tableColumns.forEach((col) => {
        if (col.checked && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })

      const params = {
        sessionid: this.$store.state.token,
        platforms: this.queryForm.platforms,
        mediaIds: this.queryForm.mediaIds,
        dataGameIds: this.queryForm.dataGameIds,
        dataGroupIds: this.queryForm.dataGroupIds,
        [this.dimImageDetail === '1' ? 'imageDetailId' : 'imageId']: this.queryForm.id,
        exportColumnOrderMap
      }

      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      if (this.sort) params.sort = this.sort
      if (this.order) params.order = this.order

      this.exportLoading = true
      exportMaterialAnalysisDetail(params).then((data) => {
        this.exportLoading = false
      })
    },
    proLoadData() {
      const prevId = this.queryForm.id
      const { platforms, id, mediaIds, dataGameIds, dataGroupIds, launchOpIdsStr, beginTime, endTime, dimImageDetail } = this.$route.query
      this.dimImageDetail = dimImageDetail || null
      this.queryForm.id = id
      this.queryForm.platforms = platforms ? platforms.split(',').map(Number) : []
      this.queryForm.mediaIds = mediaIds ? mediaIds.split(',').map(Number) : []
      this.queryForm.dataGameIds = dataGameIds ? dataGameIds.split(',').map(Number) : []
      this.queryForm.dataGroupIds = dataGroupIds ? dataGroupIds.split(',').map(Number) : []
      this.queryForm.datetime = [beginTime, endTime]

      if (launchOpIdsStr && typeof launchOpIdsStr === 'string') {
        this.queryForm.launchOpIdList = launchOpIdsStr.split(',').map(Number)
      }

      // 广告数据页面需要keep-alive缓存，但是又可以从素材分析的广告数据页面跳转过来
      // 这里判断如果路由传过来的id和当前的id不一致，那么需要重新请求数据
      // 其他情况不请求
      if (Number(prevId) !== Number(id)) {
        this.sendEvent()
      }
    },
    onTableColsChange(cols) {
      this.modalColumn = false
      this.tableColumns = cols
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    }
  },
  data() {
    return {
      dimImageDetail: null,
      platformData2,
      tableHeight: 330,
      tableColumns: [],
      rawTableCols: analysisCols,
      name: null,
      author: null,
      creatime: null,
      tableList: [], // 表格数据
      sumdata: [], // 统计数据
      exportLoading: false,

      queryForm: {
        id: '',
        datetime: [],
        mediaIds: [],
        platforms: [],
        launchOpIdList: [],
        dataGameIds: [],
        dataGroupIds: []
      }
    }
  },
  activated() {
    this.$route.name === 'materialAnalysisDetail' && this.proLoadData()
  },
  created() {
    this.$route.name === 'materialAnalysisDetail' && this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.material-report-detail {
  position: relative;

  .material-info-row {
    margin-bottom: 2px;
    &.loading {
      filter: blur(3px);
    }
    > span {
      margin-right: 8px;
      .text {
        color: red;
      }
    }
  }

  .query-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
